import React from 'react';

// Import the new component
import CollaborateBanner from '../components/CollaborateBanner';
import Hero from "../components/Hero";
import Features from "../components/Features";
import CarListings from "../components/CarListings";
import Stats from "../components/Stats";
import DownloadApp from "../components/DownloadApp";
import CtaBanner from "../components/CtaBanner";
import ServicesSection from "../components/ServicesSection";
import TestimonialSlider from "../components/TestimonialSlider";
import Faq from "../components/Faq";
import BookingBanner from "../components/BookingBanner";
import BlogList from "../components/BlogList";
import DynamicServices from '../components/DynamicServices'; // Import the new component

const Home = () => {
  return (
    <>
      <Hero />
      <Features />
      <CarListings />
      <ServicesSection />
      <DynamicServices /> 
      <Faq />
      <Stats />
      <TestimonialSlider />
      <BlogList />
      <DownloadApp />
      <BookingBanner />
      <CollaborateBanner />
      <CtaBanner />
    </>
  );
}

export default Home;